import toast from "react-hot-toast";

import { LISBlock, LISCase, LISSlide } from "pwapi";

import { StainsState } from "shared/reducers/frontLoaderReducers";

import { labelForBlock } from "util/blockUtils";
import { labelForSlide } from "util/slideUtils";

import FullScreenToast from "./FullScreenToast";

// NOTE: react-hot-toast injects styles into a <style> tag which will be
// *below* (thus overrides) style in the <head> of the document
// ... but __only for builds__ -- during development, all <style> is
// hot-reloaded and thus you don't see the same results as compiled style
const style = {
  background: "var(--red9)",
  maxWidth: "none",
  padding: 0,
};

export const toastErrorSlidesNotScannedOutMovingBlock = (
  pathCase: LISCase,
  scannedBlock: LISBlock,
  slidesNotScannedOut: LISSlide[],
  stains: StainsState
) => {
  const scannedBlockLabel = labelForBlock(scannedBlock, pathCase);
  const slidesNotScannedOutLabels = slidesNotScannedOut
    .map((s) => labelForSlide(s, pathCase, stains[s.stain_id || 0]))
    .join(", ");
  return toast.error(
    (t) => (
      <FullScreenToast t={t}>
        <h2>Scan Warning</h2>
        <h3>
          You scanned Block {scannedBlockLabel}, but Slides{" "}
          {slidesNotScannedOutLabels} have not yet been scanned out.
        </h3>
        <p>
          Please carefully consider the materials you are currently handling
        </p>
        <p>
          If you meant to scan {scannedBlockLabel}, scan out{" "}
          {slidesNotScannedOutLabels} first and then proceed with scanning{" "}
          {scannedBlockLabel}
        </p>
      </FullScreenToast>
    ),
    {
      icon: null,
      duration: 30000,
      className: "Toast--FullScreen",
      style,
    }
  );
};

export const toastErrorSlideDoesNotBelong = (
  pathCase: LISCase,
  block?: LISBlock
) => {
  return toast.error(
    (t) => (
      <FullScreenToast t={t}>
        <h2>Extreme Warning</h2>
        <h1>
          The slide you scanned does not belong to{" "}
          {block
            ? `${pathCase?.accession} Block ${labelForBlock(block, pathCase)}`
            : pathCase?.accession}
          .
        </h1>
        <p>
          Please carefully consider the materials you are currently handling.
        </p>
      </FullScreenToast>
    ),
    {
      icon: null,
      duration: Infinity,
      className: "Toast--FullScreen",
      style,
    }
  );
};
